import React from 'react';
import { cn } from '../../lib/utils';
interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'success' | 'warning' | 'alert' | 'neutral' | 'blue';
  children: React.ReactNode;
}
export function Badge({
  variant = 'default',
  className,
  children,
  ...props
}: BadgeProps) {
  const variants = {
    default: 'bg-slate-100 text-slate-800',
    success: 'bg-emerald-50 text-emerald-700 border border-emerald-200/50',
    warning: 'bg-amber-50 text-amber-700 border border-amber-200/50',
    alert: 'bg-rose-50 text-rose-700 border border-rose-200/50',
    neutral: 'bg-slate-100 text-slate-700 border border-slate-200/50',
    blue: 'bg-blue-50 text-blue-700 border border-blue-200/50'
  };
  return <span className={cn('inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium', variants[variant], className)} {...props} data-id="element-307">
      {children}
    </span>;
}